import { render, staticRenderFns } from "./FranchiseSection.vue?vue&type=template&id=1fff2df6"
import script from "./FranchiseSection.vue?vue&type=script&lang=js"
export * from "./FranchiseSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports